import * as React from 'react';
import Icon from '../Icon/Icon';
import { ReactComponent as Svg } from '../../../icons/Blocks/Blocks.svg';
export default function Blocks(props) {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    icon: Svg,
    legacy: true
  }));
}